import React, { useState } from "react";
import { Link } from "react-router-dom";

import TopStrip from "../components/TopStrip";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import HelpButton from "../components/HelpButton";

import heroBanner from "../assets/images/hero-images/web & app Development.webp";
import heroMobile from "../assets/images/mobile-banners/development-mobile.webp";
import ecommerceImg from "../assets/images/webp-images/eccomerce.44944b05.webp";
import frontendImg from "../assets/images/frontend.jfif";
import backendImg from "../assets/images/backend.jpg";
import mobileImg from "../assets/images/mobile.jpg";
import offerImg from "../assets/images/100USD.png";

import devTab1 from "../assets/images/develop-tabs/1.png";
import devTabWeb from "../assets/images/develop-tabs/Web-Devep.20c7c61e.png";
import devTabMobile from "../assets/images/develop-tabs/Mobile-Apps.4bb59397.png";

import discoveryCard from "../assets/images/develop-design-cards/Discovery.png";
import uiuxCard from "../assets/images/develop-design-cards/UIUX.png";
import agileCard from "../assets/images/develop-design-cards/Agile.png";
import cicdCard from "../assets/images/develop-design-cards/CICD.png";

import jsIcon from "../assets/images/web-service-cards/javascript.695f5796.png";
import cmsIcon from "../assets/images/web-service-cards/cms.b74d70c5.png";
import ecomIcon from "../assets/images/web-service-cards/eccomerce.fc325140.png";
import frameworkIcon from "../assets/images/web-service-cards/framework.57cd9806.png";
import phpIcon from "../assets/images/web-service-cards/php.27659f20.png";
import apiIcon from "../assets/images/web-service-cards/API.png";

import client1 from "../assets/images/develop-logo-icons/client1.684c440e.avif";
import client2 from "../assets/images/develop-logo-icons/client2.225fef63.avif";
import client3 from "../assets/images/develop-logo-icons/client3.39c5ba0e.avif";
import client4 from "../assets/images/develop-logo-icons/client4.1bd9785d.avif";
import phpLogo from "../assets/images/develop-logo-icons/php.png";
import djangoLogo from "../assets/images/develop-logo-icons/django.png";
import shopifyLogo from "../assets/images/develop-logo-icons/shopify.png";

const secondLogos = [
  client1,
  client2,
  client3,
  client4,
  phpLogo,
  djangoLogo,
  shopifyLogo,
];

function DevelopmentServices() {
  const [activeTab, setActiveTab] = useState("design");

  return (
    <>
      <TopStrip />
      <Navbar />

      {/* HERO */}
      <section style={{ marginTop: "125px" }}>
        <div className="container-fluid p-0">
          <img
            src={heroBanner}
            width="1600"
            height="520"
            alt="Web and app development banner with digital screens, code visuals, and scalable design tagline."
            className="img-fluid w-100 d-none d-md-block"
          />
          <img
            src={heroMobile}
            width="768"
            height="1000"
            alt="Web and app development banner with digital screens, code visuals, and scalable design tagline."
            className="img-fluid w-100 d-md-none d-block"
          />
        </div>
      </section>

      {/* TABS SECTION */}
      <section id="tab-section">
        <div className="container px-3 px-md-5">
          <h1
            className="text-center top-line txt-color mt-5 fw-semibold"
            style={{ textTransform: "capitalize" }}
          >
            WEB AND APP DEVELOPMENT
          </h1>
          <h1
            className="text-center my-3 text-muted"
            style={{ textTransform: "capitalize" }}
          >
            secure, scalable, and user-centric solutions
          </h1>
        </div>

        <div className="container w-75 my- custom-tab-container bg-watermark">
          <ul className="nav nav-tabs justify-content-center" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "design" ? "active" : ""}`}
                onClick={() => setActiveTab("design")}
                type="button"
              >
                WEB DESIGN
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "dev" ? "active" : ""}`}
                onClick={() => setActiveTab("dev")}
                type="button"
              >
                WEB DEVELOPMENT
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link ${activeTab === "mobile" ? "active" : ""}`}
                onClick={() => setActiveTab("mobile")}
                type="button"
              >
                MOBILE APPS
              </button>
            </li>
          </ul>

          <div className="tab-content p-3 border-top-0">
            {/* WEB DESIGN */}
            <div
              className={`tab-pane fade ${activeTab === "design" ? "show active" : ""}`}
            >
              <div className="row d-flex align-items-center text-center text-lg-start">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <h3 className="fw-semibold">
                    User-Centric Interfaces that Convert.
                  </h3>
                  <p className="m-0">
                    We don't just design pretty sites; we engineer user
                    experiences. From wireframing to high-fidelity prototypes,
                    our design process focuses on intuitive navigation, mobile
                    responsiveness, and visual storytelling that aligns
                    perfectly with your brand identity.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={devTab1}
                    alt="PHP Stack"
                    className="img-fluid mx-auto"
                    style={{ maxWidth: "80%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            {/* WEB DEVELOPMENT */}
            <div
              className={`tab-pane fade ${activeTab === "dev" ? "show active" : ""}`}
            >
              <div className="row d-flex align-items-center text-center text-lg-start">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <h3 className="fw-semibold">
                    Robust, Scalable, and Secure Code.
                  </h3>
                  <p className="m-0">
                    This is where our DevOps DNA shines. We build web
                    applications using clean, efficient code that is ready for
                    high traffic from day one. Whether it's a complex SaaS
                    platform or a dynamic corporate portal, we ensure security
                    and speed are baked into the backend.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={devTabWeb}
                    alt="MEAN Stack"
                    className="img-fluid mx-auto"
                    style={{ maxWidth: "80%", height: "auto" }}
                  />
                </div>
              </div>
            </div>

            {/* MOBILE APPS */}
            <div
              className={`tab-pane fade ${activeTab === "mobile" ? "show active" : ""}`}
            >
              <div className="row d-flex align-items-center text-center text-lg-start">
                <div className="col-lg-6 col-sm-12" data-aos="fade-right">
                  <h3 className="fw-semibold">
                    Native & Cross-Platform Excellence.
                  </h3>
                  <p className="m-0">
                    Extend your business to every pocket. We develop
                    high-performance mobile apps for iOS and Android using
                    modern frameworks like Flutter and React Native, ensuring a
                    native feel with a single, maintainable codebase.
                  </p>
                </div>
                <div
                  className="col-lg-6 col-sm-12 text-center"
                  data-aos="fade-left"
                >
                  <img
                    src={devTabMobile}
                    alt="Java Stack"
                    className="img-fluid mx-auto"
                    style={{ maxWidth: "80%", height: "auto" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* DEVOPS AGILE WORKFLOW */}
      <section className="py-5 bg-light position-relative">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">The DevOps Agile Workflow</h2>
            <p className="text-muted fs-5">
              From idea to production using automation-first DevOps practices.
            </p>
          </div>
          <div className="row g-4">
            {[
              {
                step: "01",
                title: "Discovery",
                desc: "Requirements, business logic & feasibility analysis.",
              },
              {
                step: "02",
                title: "Design",
                desc: "UI/UX wireframes, flows & interactive prototypes.",
              },
              {
                step: "03",
                title: "Development",
                desc: "Agile sprints with CI/CD and automated testing.",
              },
              {
                step: "04",
                title: "Launch",
                desc: "Automated deployment, QA & live monitoring.",
              },
            ].map((c, i) => (
              <div className="col-md-3" key={i}>
                <div className="workflow-card h-100">
                  <span className="step">{c.step}</span>
                  <h5>{c.title}</h5>
                  <p>{c.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TECHNOLOGY STACK */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold text-primary">Our Technology Stack</h2>
            <p className="text-muted fs-5">
              Carefully selected technologies for scalability and security.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-lg border-0 rounded-4 text-center p-4 tech-card">
                <img
                  src={frontendImg}
                  alt="Frontend"
                  className="mb-3 mx-auto floating-icon"
                  style={{ width: "200px" }}
                />
                <h5 className="fw-bold">Frontend</h5>
                <p className="text-muted">
                  React · Vue · Angular · Bootstrap · Tailwind
                </p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-lg border-0 rounded-4 text-center p-4 tech-card">
                <img
                  src={backendImg}
                  alt="Backend"
                  className="mb-3 floating-icon"
                  style={{ width: "200px", margin: "0 auto" }}
                />
                <h5 className="fw-bold">Backend</h5>
                <p className="text-muted">Node.js · Python · Laravel · Java</p>
              </div>
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <div className="card h-100 shadow-lg border-0 rounded-4 text-center p-4 tech-card">
                <img
                  src={mobileImg}
                  alt="Mobile"
                  className="mb-3 floating-icon mx-auto"
                  style={{ width: "170px" }}
                />
                <h5 className="fw-bold">Mobile</h5>
                <p className="text-muted">
                  Flutter · React Native · Swift · Kotlin
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE HIGHLIGHTS */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="fw-bold">Recent Work & Case Highlights</h2>
            <p className="text-muted fs-5">
              Proven solutions delivering real business impact.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-md-4">
              <div className="case-card h-100">
                <h5>FinTech Platform</h5>
                <span>Industry: FinTech</span>
                <p>Scaled to 10,000+ secure users.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="case-card h-100">
                <h5>E-Commerce Automation</h5>
                <span>Industry: E-Commerce</span>
                <p>Deployment time reduced by 60%.</p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="case-card h-100">
                <h5>Enterprise Dashboard</h5>
                <span>Industry: Enterprise</span>
                <p>Improved reporting & visibility.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW WE WORK — THE AGILE LIFECYCLE */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <span className="section-tag">HOW WE WORK</span>
            <h2 className="fw-bold mt-2">THE AGILE LIFECYCLE</h2>
            <p className="text-muted fs-5 mt-3">
              A DevOps-driven process designed for speed, stability, and
              scalability.
            </p>
          </div>
          <div className="row g-4">
            <div className="col-lg-3 col-md-6">
              <div className="agile-card h-100">
                <img
                  src={discoveryCard}
                  alt="Discovery & Strategy"
                  className="img-fluid mb-3"
                />
                <span className="step">01</span>
                <h5>Discovery & Strategy</h5>
                <p>
                  First, we define the roadmap. We analyze your business logic,
                  select the optimal technology stack (PHP, Node, Python), and
                  map out a clear development timeline aligned with your
                  business goals and budget.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="agile-card h-100">
                <img
                  src={uiuxCard}
                  alt="UI UX Design"
                  className="img-fluid mb-3"
                />
                <span className="step">02</span>
                <h5>UI / UX Design</h5>
                <p>
                  Next, we visualize the solution. We transform abstract
                  requirements into interactive wireframes and high-fidelity
                  mockups, focusing on intuitive user flows that look stunning
                  and perform flawlessly on every device.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="agile-card h-100">
                <img
                  src={agileCard}
                  alt="Agile Development"
                  className="img-fluid mb-3"
                />
                <span className="step">03</span>
                <h5>Agile Development</h5>
                <p>
                  Then, we build in sprints. Working in structured 2-week agile
                  cycles, we write clean, scalable code and integrate automated
                  testing pipelines early to catch issues fast without
                  compromising stability.
                </p>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="agile-card h-100">
                <img
                  src={cicdCard}
                  alt="CI CD Deployment"
                  className="img-fluid mb-3"
                />
                <span className="step">04</span>
                <h5>CI / CD Deployment</h5>
                <p>
                  Finally, we launch with confidence. Using CI/CD pipelines, we
                  deploy smoothly to production and activate real-time
                  monitoring to ensure security, speed, and uptime from minute
                  one.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* E-COMMERCE SOLUTION */}
      <section style={{ margin: "3rem auto" }}>
        <div className="container">
          <div className="text-center">
            <h2 className="top-line fs-1">
              High-Performance <span className="txt-color">E-Commerce</span>
            </h2>
          </div>
          <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-12 d-flex align-items-center">
              <p
                className="my-4"
                data-aos="fade-right"
                style={{ textAlign: "justify" }}
              >
                DDevOps transforms online stores into revenue engines. We help
                startups launch fast and established brands scale effortlessly.
                Unlike traditional agencies, we integrate{" "}
                <b>DevOps methodologies (CI/CD)</b> directly into your store's
                architecture. This means you can roll out new features instantly
                without downtime, handle massive traffic spikes during sales
                events, and enjoy enterprise-grade security. We ensure your
                store is always fast, always online, and always converting.
              </p>
            </div>
            <div className="col-md-6 col-lg-6 col-sm-12 text-center">
              <img
                src={ecommerceImg}
                alt="e-commerce"
                className="img-fluid"
                data-aos="fade-left"
              />
            </div>
          </div>
        </div>
      </section>

      {/* EVERYONE SECTION */}
      <section className="everyone-section position-relative d-flex justify-content-start align-items-center my-5">
        <div className="everyone-img container-fluid d-flex justify-content-center align-items-center">
          <div
            className="p-5 container rounded-4 shadow-sm"
            style={{ backgroundColor: "rgba(240,248,255,0.92)" }}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <h2 className="text-start mt-2 mb-3">
              Let's Get <span className="txt-color">Everyone Online</span>
            </h2>
            <p className="fs-5 fw-medium">
              Reliable, Responsive & Progressive Websites. Fully Managed.
            </p>
            <p className="mt-3 w-50">
              DDevOps is committed to digital inclusion. We support communities,
              startups, and small businesses by removing the barrier to entry.
              We deliver a complete, high-performance WordPress solution that
              helps you connect with the world—without breaking the bank.
            </p>
            <ul className="list-unstyled mt-4">
              <li className="mb-2">✅ Premium WordPress Setup</li>
              <li className="mb-2">✅ Mobile Responsive Design</li>
              <li className="mb-2">✅ 1 Year Hosting & Maintenance</li>
            </ul>
            <p className="text-muted mb-4">
              Development + 1 Year Operation Included
            </p>
          </div>
          <img
            src={offerImg}
            className="special-offer-png"
            alt="Special offer image"
          />
        </div>
      </section>

      {/* DEVELOPMENT PLAN */}
      <section className="my-5">
        <div className="container">
          <div className="row g-4">
            {/* CARD 1 */}
            <div
              className="col-lg-4 col-md-6 col-sm-12"
              data-aos="flip-right"
              data-aos-duration="1000"
            >
              <div className="card p-4 shadow-sm h-100 text-center">
                <h5 className="fw-bold">
                  BUILD AND <span className="txt-color">DEPLOY</span>
                </h5>
                <p className="mb-2 text-muted">
                  Best For: <strong>IT Teams & Agencies</strong>
                </p>
                <p className="small text-muted mb-3">
                  We build it, we launch it, you manage it.
                </p>
                <Link to="/contact" className="btn btn-info text-white mb-4">
                  Start Project
                </Link>
                <ul
                  className="list-unstyled text-start mx-auto"
                  style={{ maxWidth: "270px" }}
                >
                  <li className="mb-2">✅ Custom Development</li>
                  <li className="mb-2">✅ CI/CD Deployment Setup</li>
                  <li className="mb-2">✅ Source Code Handover</li>
                  <li className="mb-2">✅ Basic Documentation</li>
                  <li className="mb-2">❌ Managed Hosting (Operations)</li>
                  <li className="mb-2">❌ 3-Month Warranty</li>
                  <li className="mb-2">❌ Annual Service Contract</li>
                </ul>
              </div>
            </div>
            {/* CARD 2 */}
            <div
              className="col-lg-4 col-md-6 col-sm-12"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="card p-4 shadow-sm h-100 text-center">
                <h5 className="fw-bold">
                  BUILD AND <span className="txt-color">SUPPORT</span>
                </h5>
                <p className="mb-2 text-muted">
                  Best For: <strong>SMBs & Startups</strong>
                </p>
                <p className="small text-muted mb-3">
                  We build it and ensure it runs perfectly for the first
                  quarter.
                </p>
                <Link to="/contact" className="btn btn-info text-white mb-4">
                  Start Project
                </Link>
                <ul
                  className="list-unstyled text-start mx-auto"
                  style={{ maxWidth: "270px" }}
                >
                  <li className="mb-2">✅ Custom Development</li>
                  <li className="mb-2">✅ CI/CD Deployment Setup</li>
                  <li className="mb-2">✅ Source Code Handover</li>
                  <li className="mb-2">✅ Standard Maintenance</li>
                  <li className="mb-2">❌ Managed Hosting (Operations)</li>
                  <li className="mb-2">✅ 3-Month Warranty</li>
                  <li className="mb-2">❌ Annual Service Contract</li>
                </ul>
              </div>
            </div>
            {/* CARD 3 */}
            <div
              className="col-lg-4 col-md-6 col-sm-12 mx-md-auto"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="card p-4 shadow-sm h-100 text-center">
                <h5 className="fw-bold">
                  BUILD AND <span className="txt-color">OPERATE</span>
                </h5>
                <p className="mb-2 text-muted">
                  Best For: <strong>Enterprises & Scaling Apps</strong>
                </p>
                <p className="small text-muted mb-3">
                  We build, host, and evolve your app.
                </p>
                <Link to="/contact" className="btn btn-info text-white mb-4">
                  Partner With Us
                </Link>
                <ul
                  className="list-unstyled text-start mx-auto"
                  style={{ maxWidth: "270px" }}
                >
                  <li className="mb-2">✅ Custom Development</li>
                  <li className="mb-2">✅ CI/CD Deployment Setup</li>
                  <li className="mb-2">✅ Full Source Code Access</li>
                  <li className="mb-2">✅ Proactive Maintenance</li>
                  <li className="mb-2">✅ Managed Hosting (Operations)</li>
                  <li className="mb-2">✅ 3-Month Warranty Included</li>
                  <li className="mb-2">✅ Annual Service Contract</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* OUR EXPERTISE */}
      <section className="second-logo-slider bg-light py-3">
        <div className="container my-5">
          <div className="text-center mb-5">
            <h1 className="fw-bold mb-2">
              OUR <span className="txt-color">EXPERTISE</span>
            </h1>
            <p className="text-muted fs-5">
              Mastering the technologies that power the modern web.
            </p>
          </div>

          {/* Expertise Carousel */}
          <div
            id="expertiseCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
          >
            <div className="carousel-inner py-4 px-3">
              {/* Slide 1 */}
              <div className="carousel-item active">
                <div className="row justify-content-center g-4">
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={jsIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="Full Stack JS"
                      />
                      <h5 className="fw-bold mb-2">FULL STACK JS</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>Modern & Reactive:</strong> We build dynamic,
                        single-page applications (SPAs) using Angular, React,
                        and Vue.js. On the backend, we leverage Node.js and
                        Express to create fast, event-driven architectures that
                        handle massive concurrency.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={cmsIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="CMS Development"
                      />
                      <h5 className="fw-bold mb-2">CMS DEVELOPMENT</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>Secure & Scalable:</strong> We go beyond basic
                        templates. We build custom, modular, and
                        high-performance sites using WordPress, Joomla, and
                        Drupal. Our focus is on security hardening and
                        optimizing core web vitals for SEO rankings.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={ecomIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="E-Commerce"
                      />
                      <h5 className="fw-bold mb-2">E-COMMERCE</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>Conversion Focused:</strong> Building stores
                        that sell. Whether it's WooCommerce, Magento, or
                        Shopify, we customize the shopping experience to
                        maximize conversion rates. We ensure your checkout is
                        secure and your inventory syncs in real-time.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div className="carousel-item">
                <div className="row justify-content-center g-4">
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={frameworkIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="MVC Frameworks"
                      />
                      <h5 className="fw-bold mb-2">MVC FRAMEWORKS</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>Structured Code:</strong> For complex logic, we
                        rely on battle-tested frameworks. We specialize in
                        Laravel (PHP), Django (Python), and Spring Boot (Java)
                        to build enterprise applications that are maintainable,
                        secure, and easy to scale.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={phpIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="Core PHP"
                      />
                      <h5 className="fw-bold mb-2">CORE PHP</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>The Web Engine:</strong> PHP powers 70% of the
                        web, and we are masters of it. From maintaining legacy
                        applications to building modern, object-oriented
                        systems, we write clean, optimized PHP code that runs
                        fast and secure.
                      </p>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="card text-center shadow border-0 rounded-4 p-4 h-100 bg-white expertise-card">
                      <img
                        src={apiIcon}
                        className="mx-auto mb-3"
                        style={{ height: "70px" }}
                        alt="API Integration"
                      />
                      <h5 className="fw-bold mb-2">API INTEGRATION</h5>
                      <p className="text-muted" style={{ fontSize: "0.95rem" }}>
                        <strong>Connected Ecosystems:</strong> We integrate
                        RESTful and GraphQL APIs to connect your applications
                        with third-party services. From payment gateways to
                        CRMs, we ensure seamless data flow, secure
                        authentication, and scalable integrations that power
                        modern businesses.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Carousel Buttons */}
            <div className="d-flex justify-content-center gap-3 mt-4">
              <button
                className="btn btn-outline-primary"
                type="button"
                data-bs-target="#expertiseCarousel"
                data-bs-slide="prev"
              >
                Prev
              </button>
              <button
                className="btn btn-outline-primary"
                type="button"
                data-bs-target="#expertiseCarousel"
                data-bs-slide="next"
              >
                Next
              </button>
            </div>
          </div>

          {/* Logo Slider */}
          <div className="second-logo-wrapper mt-5">
            <h3 className="text-center fw-bold text-dark mb-4 mt-5 d-block">
              <span className="px-3 py-2">Tools & Technologies We Master</span>
            </h3>
            <div className="second-logo-track d-flex align-items-center">
              {[...secondLogos, ...secondLogos].map((logo, i) => (
                <img
                  key={i}
                  src={logo}
                  className="second-slide-logo-img"
                  alt=""
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <HelpButton />
    </>
  );
}

export default DevelopmentServices;
